import { createFileRoute } from "@tanstack/react-router"
import { Dashboard } from "../../components/Dashboard/HelloPage.tsx";

// function ErrorButton() {
//     return (
//         <button
//             onClick={() => {
//                 throw new Error('This is your first error!');
//             }}
//         >
//             Break the world
//         </button>
//     );
// }


export const Route = createFileRoute("/_layout/")({
  component: Dashboard,
    // component: ErrorButton
})
